'use strict';

import React from 'react';

class About extends React.Component {
  render() {
    return (
      <div className="about-component" id="empresa">
        <h2 className="title section-title">Empresa</h2>
        <h4 className="title section-subtitle">
          Temos como missão promover o sucesso dos clientes,
          apoiando as empresas, empresários e particulares
          com o cumprimento das suas obrigações contabilísticas,
          fiscais e laborais.
        </h4>
        <div className="section-content">
          <p>
            A Toc To Me, constituída em 2006, é especializada na prestação de
            serviços de contabilidade e na gestão de recursos humanos.
          </p>
          <p>
            Temos como missão promover o sucesso dos clientes, apoiando as
            empresas, empresários e particulares com o cumprimento das suas
            obrigações contabilísticas, fiscais e laborais.
          </p>
          <p>
            Apostamos numa relação de proximidade possibilitando assim aos
            nossos clientes o crescimento dos seus negócios de forma contínua e
            sustentada.
          </p>
          <p>
            A qualidade dos nossos serviços, sempre orientados para a satisfação
            das necessidades e realização dos objectivos dos nossos clientes, é
            sustentada pela equipa de colaboradores que exercem a profissão com
            grande sentido de rigor, responsabilidade e confidencialidade.
          </p>
        </div>
      </div>
    );
  }
}

About.displayName = 'About';

// Uncomment properties you need
// Home.propTypes = {};
// Home.defaultProps = {};

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js